import React from "react";
import "./careers.scss";

//Shapes
import { TitleBar } from "../../Shapes/Shapes";

//Images
import crew from "./images/crew.jpg";
import companies1 from "./images/pol.png";
import companies2 from "./images/yardmap.png";
import companies3 from "./images/pol-academy.png";
import companies4 from "./images/aimm.png";
import services1 from "./images/bonus.svg";
import services2 from "./images/graduation-cap.svg";
import services3 from "./images/growth.svg";

// SEO
// import SEO from "../../SEO/index.js";

//Utils
import withMotion from "../../Utils/withMotion";

const index = () => {
  return (
    <div className="container-fluid">
      {/* <SEO
        title="Los Angeles Landscaping Design Company - Pacific Outdoor Living"
        description="Pacific Outdoor Living is the top landscaping company in Los Angeles, with award-winning designers and unmatched service & quality."
        profileURL={"https://www.pacificoutdoorliving.com/"}
        type="website"
      /> */}
      <div className="row justify-content-center page-career">
        <div className="col-11 col-xl-10">
          <div className="row justify-content-center">
            <div className="col career-hero">
              <div className="row h-100">
                <div className="col my-auto">
                  <h1 className="font-weight-bold">Careers</h1>
                </div>
              </div>
            </div>
          </div>
          <div className="row justify-content-center my-5">
            <div className="col-12 col-md-8 col-lg-8 col-xl-5">
              <h2 className="text-center font-weight-normal">
                Careers at Pacific Pavingstone
              </h2>
              <TitleBar />
            </div>
          </div>
          <div className="row justify-content-center mt-3">
            <div className="col-11 col-lg-9">
              <p>
                Pacific Pavingstone is continually pushing boundaries in the
                hardscape field. With over 20 years of experience under our
                belt, we are no strangers to hard work and the value of an
                excellent team. We are a family company and strive to make sure
                our team feels valued and supported.
              </p>
            </div>
            <div className="col-11 col-lg-9 text-center">
              <img src={crew} alt="Crew" />
            </div>
            <div className="col-11 col-lg-9 mt-2">
              <p>
                Pacific Pavingstone is a part of a group of sister companies
                that are focused on providing excellent quality and customer
                service to the community.
              </p>
            </div>
          </div>
          <div className="row justify-content-center mt-3 services-images">
            <div className="col-8 col-md-4 col-lg-3 mt-3 mt-md-0 text-center">
              <img src={companies1} alt="Services" />
            </div>
            <div className="col-8 col-md-4 col-lg-3 mt-3 mt-md-0 text-center">
              <img src={companies2} alt="Services" />
            </div>
          </div>
          <div className="row justify-content-center mt-3 services-images">
            <div className="col-8 col-md-4 col-lg-3 mt-3 mt-md-0 text-center">
              <img src={companies3} alt="Services" />
            </div>
            <div className="col-8 col-md-4 col-lg-3 mt-3 mt-md-0 text-center">
              <img src={companies4} alt="Services" />
            </div>
          </div>
        </div>
      </div>
      <div className="row justify-content-center section-services">
        <div className="col-11 col-lg-md-10 col-lg-9">
          <div className="row justify-content-center">
            <div className="col-12 mb-4">
              <h2 className="text-center">What we bring to the table:</h2>
            </div>
            <div className="col-8 col-md-4 col-lg-3 text-center">
              <img src={services1} alt="Services" />
              <p>
                Bonus
                <br />
                Options
              </p>
            </div>
            <div className="col-8 col-md-4 col-lg-3 text-center">
              <img src={services2} alt="Services" />
              <p>
                Training &amp;
                <br />
                Certification Options
              </p>
            </div>
            <div className="col-8 col-md-4 col-lg-3 text-center">
              <img src={services3} alt="Services" />
              <p>
                Growth
                <br />
                Opportunities
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="row justify-content-center page-career mt-5">
        <div className="col-11 col-xl-10">
          <div className="row justify-content-center">
            <div className="col-11 col-lg-9">
              <h3 className="text-center">
                We are currently looking to hire talented individuals for the
                following rolls:
              </h3>
            </div>
            <div className="col-11 col-lg-9 my-5">
              <h3 className="text-center">Outside Sales Representative</h3>
              <p>
                We are currently looking for a paving stone sales rep, with a
                history in sales and the ability to close. You will be selling
                concrete paver installations (driveways, patios, pool decks,
                etc.). Previous experience in construction sales is a must.
              </p>
            </div>
            <div className="col-11 col-lg-9">
              <hr />
            </div>

            <div className="col-11 col-lg-9 my-5">
              <h3 className="text-center">Landscape Construction Foreman</h3>
              <p>
                We are currently seeking a Superintendent/Project Manager who is
                completely knowledgeable in landscape, masonry, pools,
                hardscapes trades and can perform the routine functions of the
                job, which include overseeing the construction of multiple jobs,
                ensuring each project comes in under the estimated hours,
                coordinates each of the different trades, interacts with home
                owners regarding their project to ensure they are satisfied,
                ensures the project is being installed correctly and collects
                installment payments on each job.
              </p>
            </div>
            <div className="col-11 col-lg-9">
              <hr />
            </div>

            <div className="col-11 col-lg-9 my-5">
              <p>
                To inquire about any positions listed, please email{" "}
                <a
                  href="mailto:careers@pacificoutdoorliving.com"
                  className="text-blue"
                >
                  careers@pacificoutdoorliving.com
                </a>{" "}
                with your resume and cover letter.
              </p>
              <p>We look forward to hearing from you!</p>
            </div>
            <div className="col-11 col-lg-9 text-center mb-5">
              <a href="mailto:careers@pacificoutdoorliving.com">
                <button className="button-main button-blue">
                  Get In Touch
                </button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default withMotion(index);
